import { Directive } from '@angular/core';

@Directive({
  selector: '[psPageSubtitle]',
  standalone: true,
  host: {
    class: 'ps-page-subtitle',
  },
})
export class PageSubtitleDirective {}
